import React, { useEffect, useRef } from 'react';
import NotFound from './NotFound';
import InternalServerError from './InternalServerError';

export enum ErrorType { 
  NOT_FOUND = "notFound", // error code 404 not found
  INTERNAL_SERVER_ERROR = "internalServerError", // error code 500 internal server error - to display on form submission failure
  NETWORK_ERROR = "networkError", // error code 503 service unavailable
}

interface ErrorScreenProps {
  errorType: ErrorType;
}

const ErrorScreen: React.FC<ErrorScreenProps> = ({ errorType }) => {
  const ref = useRef<HTMLDivElement|null>(null)

  useEffect(() => {
    if(ref.current && ref.current.parentNode) {
      (ref.current.parentNode.previousSibling as HTMLElement).style.display ="none"
    }
  }, [])
  return (
    <div ref={ref} className="container h-screen p-0 mt-[27px]">
      {
        errorType === ErrorType.NOT_FOUND
          ? <NotFound />
          : errorType === ErrorType.INTERNAL_SERVER_ERROR
            ? <InternalServerError />
            : null
      }
    </div>
  )
}

export default ErrorScreen;